export default __webpack_public_path__ + "images/moderation-tick-icon.2ceefbd1b76b3698932cf8b30b714917.svg";